import _implicitStylesheets from "./deleteIconButton.css";
import _implicitScopedStylesheets from "./deleteIconButton.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "delete": true,
    "slds-grid": true
  },
  attrs: {
    "tabindex": "0"
  },
  key: 0
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_custom_element("c360-icon", _c360Icon, {
    props: {
      "iconName": "utility:delete",
      "iconDescription": $cmp.description,
      "size": "xx-small",
      "iconClass": "normal"
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.clicked))
    }
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4ku7mk28rao";
tmpl.legacyStylesheetToken = "appx-deleteIconButton_deleteIconButton";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
